module.exports = __webpack_public_path__ + "img/ss1_glare.a13be7a6.png";